import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type GetUserAPIKeysResponse = {
  keyId: string;
  name: string;

  key: string;
  partialHint: string;
  status: 'active';

  createdAt: string;
  lastUsedAt: string;
}[];

export const useGetUserAPIKeysQuery = () => {
  return useQuery({
    queryKey: ['auth', 'keys'],
    queryFn: async () => {
      const { data } = await client.get<{ body: GetUserAPIKeysResponse }>(`/auth/keys`);

      return data.body;
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};
